import { apiClient } from '../apiClient';
import type { ApiResponse } from '../http/types';
import type {
  DistributionGroupSummary,
  DistributionGroupDetail,
  DistributionRecipientSummary,
  DistributionRecipientDetail,
  CreateDistributionGroupRequest,
  UpdateDistributionGroupRequest,
  CreateRecipientRequest,
} from './distribution.types';

const base = '/api/Distribution';

// Groups
export function listDistributionGroups(): Promise<ApiResponse<DistributionGroupSummary[]>> {
  return apiClient.get<DistributionGroupSummary[]>(`${base}/distribution-groups`);
}

export function createDistributionGroup(payload: CreateDistributionGroupRequest): Promise<ApiResponse<DistributionGroupSummary>> {
  return apiClient.post<DistributionGroupSummary>(`${base}/distribution-groups`, payload);
}

export function getDistributionGroup(id: string | number): Promise<ApiResponse<DistributionGroupDetail>> {
  return apiClient.get<DistributionGroupDetail>(`${base}/distribution-groups/${encodeURIComponent(id)}`);
}

export function deleteDistributionGroup(id: string | number): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`${base}/distribution-groups/${encodeURIComponent(id)}`);
}

export function updateDistributionGroup(id: string | number, payload: UpdateDistributionGroupRequest): Promise<ApiResponse<DistributionGroupSummary>> {
  return apiClient.put<DistributionGroupSummary>(`${base}/distribution-groups/${encodeURIComponent(id)}`, payload);
}

// Recipients
export function listRecipients(): Promise<ApiResponse<DistributionRecipientSummary[]>> {
  return apiClient.get<DistributionRecipientSummary[]>(`${base}/recipients`);
}

export function getRecipient(id: string | number): Promise<ApiResponse<DistributionRecipientDetail>> {
  return apiClient.get<DistributionRecipientDetail>(`${base}/recipients/${encodeURIComponent(id)}`);
}

export function addRecipientToGroup(groupId: string | number, payload: CreateRecipientRequest): Promise<ApiResponse<DistributionRecipientDetail>> {
  return apiClient.post<DistributionRecipientDetail>(`${base}/distribution-groups/${encodeURIComponent(groupId)}/recipients`, payload);
}

export function editRecipientToGroup(groupId: string | number, payload: CreateRecipientRequest): Promise<ApiResponse<DistributionRecipientDetail>> {
  return apiClient.put<DistributionRecipientDetail>(`${base}/recipients/${encodeURIComponent(groupId)}`, payload);
}

export function removeRecipientFromGroup(groupId: string | number, recipientId: string | number): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`${base}/distribution-groups/${encodeURIComponent(groupId)}/recipients/${encodeURIComponent(recipientId)}`);
}
